// ==========================================================================
// Notice Bar
// ==========================================================================
//
// Dismiss behaviour for the site notice bar (_partials/_notice_bar.twig).
// Self-hosted replacement for the Hello Bar widget. Markup and initial
// visibility are handled in the template; this only closes the bar and
// remembers that choice.

"use strict";

var NOTICE_BAR_SELECTOR = '.js-NoticeBar';

function rememberDismissal(key) {
    if (!key) return;
    try {
        window.localStorage.setItem(key, '1');
    } catch (e) {
        // Private browsing or storage disabled - the bar simply returns next visit.
    }
}

function closeNoticeBar(bar) {
    if (!bar || bar.hidden) return;
    bar.hidden = true;
    rememberDismissal(bar.getAttribute('data-notice-key'));
}

function initNoticeBar() {
    var bar = document.querySelector(NOTICE_BAR_SELECTOR);
    if (!bar) return; // safely no-op on pages without a notice bar

    var closeButton = bar.querySelector('.js-NoticeBar-close');
    if (closeButton) {
        closeButton.addEventListener('click', function () {
            closeNoticeBar(bar);
        });
    }

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
            closeNoticeBar(bar);
        }
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNoticeBar);
} else {
    initNoticeBar();
}
